import { CompactText } from 'ui/CompactText';
import type { FC } from 'react';

import { FadeIn } from 'ui/kit/uiMotion';

import classes from './StudentProfileChanges.module.scss';
import type { IProfile } from '../model/types';

type Props = {
  profile: IProfile;
  comment?: string | null;
  onFix: () => void;
};

export const StudentProfileChanges: FC<Props> = ({ profile, comment, onFix }) => {
  const note = comment?.trim();

  return (
    <FadeIn>
      <main className={classes.page}>
        <section className={classes.card}>
          <h1 className={classes.title}>Профиль ученика</h1>
          <span className={classes.chip}>
            <span className={classes.chipDot} aria-hidden />
            Нужны изменения
          </span>
          <h2 className={classes.heading}>Уточни данные</h2>
          <p className={classes.body}>
            {note ||
              'В профиле нужны уточнения. Остальные данные можно оставить без изменений.'}
          </p>

          <div className={classes.field}>
            <p className={classes.label}>Имя</p>
            <p className={classes.value}>{profile.name || ' - '}</p>
            <CompactText className={classes.hint} tone={'info'}>Укажи имя ученика, который будет заниматься.</CompactText>
          </div>

          <p className={classes.foot}>
            После сохранения уточнений профиль снова поступит на проверку. Чаты
            откроются после одобрения.
          </p>

          <button type="button" className={classes.primary} onClick={onFix}>
            Исправить данные
          </button>
        </section>
      </main>
    </FadeIn>
  );
};
